import React from 'react';
import { BunkeringStatus } from 'src/types/ViewModel/Bunkering/BunkeringStatus';
import { canUserChangeStatus } from '../../BunkeringUtils';
import { ActiveFromDateWrapper, BunkeringStatusButton, BunkeringStatusChangeNote, DatePickerWrapper } from '../../Bunkering.styles';
import OdfjellDatePicker from 'src/components/common/date-picker/OdfjellDatePicker';
import { getLuxonDateTime, isDateAfter } from 'odfjell-date-time-utils/dateTimeUtils';
import { Bunkering } from 'src/types/ViewModel/Bunkering/Bunkering';
import { BunkeringStatusEnum, getStatusName } from 'src/types/ViewModel/Bunkering/BunkeringEvent';
import OdfjellPanel, { PANEL_CONSTANTS } from 'src/components/ui/odfjellPanel/OdfjellPanel';

interface BunkerRegStatusChangeModalProps {
    isOpen: boolean;
    selectedBunkering: Bunkering;
    newStatus: BunkeringStatus;
    onUpdateDate: (date: Date) => void;
    onClose: () => void;
    onSave: () => void;
}

const BunkerRegStatusChangeModal: React.FC<BunkerRegStatusChangeModalProps> = ({
    isOpen,
    selectedBunkering,
    newStatus,
    onUpdateDate,
    onClose,
    onSave,
}) => {
    const handleSave = () => {
        onSave();
        onClose();
    };

    if (!isOpen) {
        return null;
    }

    return (
        <OdfjellPanel
            headerTitle={`Change status of ${selectedBunkering?.bunkeringReference} to: ${getStatusName(newStatus?.status)}`}
            defaultPosition="center"
            panelWidth={PANEL_CONSTANTS.LARGE_WIDTH}
            onAction={handleSave}
            actionButtonText="Save"
            isActionDisabled={
                !newStatus ||
                !newStatus.activeFromDate ||
                (selectedBunkering.currentStatus && isDateAfter(selectedBunkering.currentStatus.activeFromDate, newStatus.activeFromDate))
            }
            onCancel={onClose}
            showCancelButton={true}
            preventOutsideClose
        >
            {
                <div>
                    {canUserChangeStatus(selectedBunkering?.currentStatus) && (
                        <>
                            <div style={{ textAlign: 'center' }}>Active from date:</div>
                            <ActiveFromDateWrapper>
                                <DatePickerWrapper>
                                    <OdfjellDatePicker
                                        disabled={!newStatus}
                                        format={'dd.MM.yyyy'}
                                        placeholder={''}
                                        value={getLuxonDateTime(newStatus?.activeFromDate)}
                                        onChange={(date) => onUpdateDate(date.toJSDate())}
                                    />
                                </DatePickerWrapper>
                                <BunkeringStatusButton onClick={() => onUpdateDate(new Date())}>Today</BunkeringStatusButton>
                            </ActiveFromDateWrapper>
                            {newStatus?.status === BunkeringStatusEnum.Approved && (
                                <BunkeringStatusChangeNote>
                                    <p>
                                        The date of approval should be the day FTA results are received. The bunker reference will be available in AOL
                                        for consumption the day after this date.
                                    </p>
                                </BunkeringStatusChangeNote>
                            )}
                            {newStatus?.status === BunkeringStatusEnum.InUse && !selectedBunkering.approvedForUseAt && (
                                <BunkeringStatusChangeNote>
                                    <p>
                                        Bypassing approval, the fuel will be available for consumption after this date, regardless of FTA results.
                                        Please remember to approve the fuel later when FTA results are received.
                                    </p>
                                </BunkeringStatusChangeNote>
                            )}
                        </>
                    )}
                </div>
            }
        </OdfjellPanel>
    );
};

export default BunkerRegStatusChangeModal;
